/**
 * @type {string}
 * @description - The server maintenance web component.
 */
export const SERVER_MAINTENANCE_WEB_COMPONENT = 'server-maintenance-component';
